import React from 'react';
import {
    CDBSidebar,
    CDBSidebarContent,
    CDBSidebarHeader,
    CDBSidebarMenu,
    CDBSidebarMenuItem,
} from 'cdbreact';
import { NavLink } from 'react-router-dom';

function Sidebar() {

    return (
        <div style={{ display: 'flex', height: '100vh', overflow: 'scroll initial' }}>
            <CDBSidebar textColor="#fff" backgroundColor="#034d4a">
                <CDBSidebarHeader prefix={<i className="fa fa-bars fa-large"></i>}>
                    <a href="/dashboard" className="text-decoration-none" style={{
                        color: 'inherit', fontWeight: 'bold',
                        letterSpacing: '1px'
                    }}>
                        User Panel
                    </a>
                </CDBSidebarHeader>

                <CDBSidebarContent className="sidebar-content">
                    <CDBSidebarMenu>
                        <NavLink to="/dashboard" className="hover" activeclassname="activeClicked">
                            <CDBSidebarMenuItem icon="th-large"  style={{
                                fontWeight: 'bold',
                                letterSpacing: '1px'
                            }}>Dashboard</CDBSidebarMenuItem>
                        </NavLink>
                        <NavLink to="/add-patient" activeclassname="activeClicked">
                            <CDBSidebarMenuItem icon="user" style={{
                                fontWeight: 'bold',
                                letterSpacing: '1px'
                            }}>Add Patient
                            </CDBSidebarMenuItem>
                        </NavLink>
                        <NavLink to="/patient-list" activeclassname="activeClicked">
                            <CDBSidebarMenuItem icon="users" style={{
                                fontWeight: 'bold',
                                letterSpacing: '1px'
                            }}>All Patient
                            </CDBSidebarMenuItem>
                        </NavLink>
                        <NavLink to="/case-list" activeclassname="activeClicked">
                            <CDBSidebarMenuItem icon="users" style={{
                                fontWeight: 'bold',
                                letterSpacing: '1px'
                            }}>All Case 
                            </CDBSidebarMenuItem>
                        </NavLink>
                        {/* <NavLink to="/add-epsiode" activeclassname="activeClicked">
                            <CDBSidebarMenuItem icon="columns" style={{
                                fontWeight: 'bold',
                                letterSpacing: '1px'
                            }}>Add Epsiode
                            </CDBSidebarMenuItem>
                        </NavLink> */}
                        {/* <NavLink to="/add-studymaterial" activeclassname="activeClicked">
                            <CDBSidebarMenuItem icon="columns" style={{
                                fontWeight: 'bold',
                                letterSpacing: '1px'
                            }}>Study Material
                            </CDBSidebarMenuItem>
                        </NavLink>
                        <NavLink to="/add-teacherlist" activeclassname="activeClicked">
                            <CDBSidebarMenuItem icon="columns" style={{
                                fontWeight: 'bold',
                                letterSpacing: '1px'
                            }}>Teacher List
                            </CDBSidebarMenuItem>
                        </NavLink>
                        <CDBSidebarMenuItem icon="columns" onClick={handleToggle} style={{
                            fontWeight: 'bold',
                            letterSpacing: '1px'
                        }}>Payment
                        </CDBSidebarMenuItem>
                        <NavLink to="/all-user" activeclassname="activeClicked">
                            <CDBSidebarMenuItem icon="columns" style={{
                                fontWeight: 'bold',
                                letterSpacing: '1px'
                            }}>All User
                            </CDBSidebarMenuItem>
                        </NavLink>
                        <NavLink to="/task-assign" activeclassname="activeClicked">
                            <CDBSidebarMenuItem icon="columns" style={{
                                fontWeight: 'bold',
                                letterSpacing: '1px'
                            }}>Task Assign
                            </CDBSidebarMenuItem>
                        </NavLink>
                        </div>
                         <NavLink to="/task-assign" activeclassname="activeClicked">
                            <CDBSidebarMenuItem icon="columns" style={{
                                fontWeight: 'bold',
                                letterSpacing: '1px'
                            }}>Task Assign
                            </CDBSidebarMenuItem>
                        </NavLink>  */}
                    </CDBSidebarMenu>
                </CDBSidebarContent>
            </CDBSidebar>
        </div>
    )
}

export default Sidebar;